import { Backdrop, CircularProgress } from '@mui/material';

type LoadingScreenProps = {
    loading: boolean;
};

const LoadingScreen = (props: LoadingScreenProps) => {
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: 10000,
            }}
            open={props.loading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};

export default LoadingScreen;
